import { render, staticRenderFns } from "./ConversationDetail.vue?vue&type=template&id=aa8715e0&scoped=true"
import script from "./ConversationDetail.vue?vue&type=script&lang=js"
export * from "./ConversationDetail.vue?vue&type=script&lang=js"
import style0 from "./ConversationDetail.vue?vue&type=style&index=0&id=aa8715e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8715e0",
  null
  
)

export default component.exports